import { dao } from '@platform/dao';
import type { IRecord } from '@platform/core/types';
import { baseApi, listTag, run } from '@platform/state/api';
import type { IRecordsOfTypesArg } from './IRecordsOfTypesArg';

/**
 * Записи кількох типів одним запитом стану (календар партії): тип → усі записи (посторінково до стелі 1000, як listAllRecords); тип, який не
 * вдалося прочитати, дає порожній список. Кешується зі списковими тегами цих типів, тож нові й змінені записи оновлюють календар.
 */
export const partyCalendarApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    recordsOfTypes: b.query<Record<string, IRecord[]>, IRecordsOfTypesArg>({
      queryFn: ({ ws, types }) => run(async () => {
        const settled = await Promise.allSettled(types.map((rt) => dao.records.listAll(ws, rt)));
        return Object.fromEntries(settled.map((r, i) => [types[i], r.status === 'fulfilled' ? r.value.items : []]));
      }),
      providesTags: (_r, _e, { types }) => types.map(listTag),
    }),
  }),
});

export const { useRecordsOfTypesQuery } = partyCalendarApi;
